import type { GeneratedDefinition } from "@keydials/api-client";
import { hasItems, setKind, type SegmentNoun } from "@keydials/dial-workspace";
import { builderCopy as copy, fieldName, fill, nounValues } from "./copy";

/**
 * What Start asks before a checklist dial becomes one colour per action point (KEY-560), or null when the switch loses nothing.
 * It removes every item and every field asked of each item, so it asks when the dial has either, and names the fields it would
 * take. The names come from a dry run of the switch itself, so the question can't list something different from what goes.
 */
export function switchToSimpleQuestion(model: GeneratedDefinition, noun: SegmentNoun): string | null {
  const items = hasItems(model);
  const { removedFieldLabels } = setKind(model, "Simple");
  if (!items && removedFieldLabels.length === 0) return null;

  const words = nounValues(noun);
  if (removedFieldLabels.length === 0) return fill(copy.start.switchToOneColour, words);
  const name = removedFieldLabels.map(fieldName).join(", ");
  return fill(items ? copy.start.switchToOneColourWithItemFields : copy.start.switchToOneColourItemFieldsOnly, { ...words, name });
}
